__webpack_require__.p = "https://eventos.utpl.edu.ec/coloquio-internacional-docente/";